<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="innerVisible"
    width="800px"
    append-to-body
    :before-close="handleClose"
  >
    <div class="dialog-toolbar">
      <el-button type="primary" size="small" @click="openAddForm">新增</el-button>
      <el-button type="primary" size="small" @click="refreshList">刷新</el-button>
    </div>
    <industry-list
      ref="industryList"
      :pid="parentRow.id"
      @add-child="openChildDialog"
      @edit="openEditForm"
      @changed="$emit('changed')"
    ></industry-list>

    <el-dialog
      :title="form.id ? '编辑类型' : '新增类型'"
      :visible.sync="formVisible"
      width="500px"
      append-to-body
      :before-close="closeForm"
    >
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="上级类型">
          <el-input :value="parentRow.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="类型名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入类型名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeForm">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>

    <industry-child-dialog
      v-if="childDialogVisible"
      :visible.sync="childDialogVisible"
      :parent-row="childParentRow"
      @changed="onChildChanged"
    ></industry-child-dialog>
  </el-dialog>
</template>

<script>
import IndustryList from "./IndustryList.vue";

export default {
  name: "IndustryChildDialog",
  components: {
    IndustryList,
    IndustryChildDialog: () => import("./IndustryChildDialog.vue"),
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    parentRow: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formVisible: false,
      childDialogVisible: false,
      childParentRow: null,
      form: {
        id: "",
        pid: "",
        name: "",
      },
      rules: {
        name: [{ required: true, message: "请输入类型名称", trigger: "blur" }],
      },
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    dialogTitle() {
      return `${this.parentRow.name} - 子类型管理`;
    },
  },
  methods: {
    refreshList() {
      this.$refs.industryList && this.$refs.industryList.getData();
    },
    openAddForm() {
      this.form = {
        id: "",
        pid: this.parentRow.id,
        name: "",
      };
      this.formVisible = true;
    },
    openEditForm(row) {
      this.form = {
        id: row.id,
        pid: row.pid,
        name: row.name,
      };
      this.formVisible = true;
    },
    openChildDialog(row) {
      this.childParentRow = row;
      this.childDialogVisible = true;
    },
    onChildChanged() {
      this.refreshList();
      this.$emit("changed");
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        const url = this.form.id
          ? "/api/shop_industry/edit"
          : "/api/shop_industry/add";
        this.$axios.post(url, this.$qs.stringify(this.form)).then((res) => {
          if (res.data.code == 1) {
            this.$message.success("操作成功");
            this.closeForm();
            this.refreshList();
            this.$emit("changed");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    closeForm() {
      this.form = { id: "", pid: "", name: "" };
      this.formVisible = false;
    },
    handleClose() {
      this.innerVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-toolbar {
  margin-bottom: 10px;
  display: flex;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopIndustry/IndustryChildDialog.vue